/*=========================================================================================
  File Name: modulePatients.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./modulePatientsState.js"
import mutations from "./modulePatientsMutations.js"
import actions from "./modulePatientsActions.js"
import getters from "./modulePatientsGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

